import { render, staticRenderFns } from "./CreateNewSmsMessageForm.vue?vue&type=template&id=35301a42"
import script from "./CreateNewSmsMessageForm.vue?vue&type=script&lang=js"
export * from "./CreateNewSmsMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports